export default "__VITE_ASSET__CGN2zl7d__"